import { createContext, useContext } from "react";

export type SettingsInitialNavigation = {
  pathname?: string;
  hash?: string;
};

const SettingsInitialNavigationContext =
  createContext<SettingsInitialNavigation>({});

export function useSettingsInitialNavigation(): SettingsInitialNavigation {
  return useContext(SettingsInitialNavigationContext);
}

export const SettingsInitialNavigationProvider =
  SettingsInitialNavigationContext.Provider;
